
const useQueryParams = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  const obj: {[k: string]: string} = Object.fromEntries(params);
  return obj;
}

export default useQueryParams;
